import type { Columns } from '@openx/types/tableHelpers.ts';
import type { TaxonomyRow } from '../types.ts';
import { NameCell } from './components/NameCell.tsx';
import { SourceCell } from './components/SourceCell.tsx';

const snakeCaseToText = string => {
  return string.replace(/^_*(.)|_+(.)/g, (_s, c, d) => (c ? c.toUpperCase() : ` ${d.toUpperCase()}`));
};

export const tableColumns: Columns<TaxonomyRow> = [
  {
    ellipsis: true,
    ellipsisMaxWidth: '650px',
    key: 'name',
    render: (data, highlighter) => <NameCell segment={data} highlighter={highlighter} />,
    title: 'Name',
    width: '40%',
    disabled: true,
  },

  {
    key: 'segment_sub_category',
    render: ({ segment_sub_category }) => (segment_sub_category ? snakeCaseToText(segment_sub_category) : ' '),
    title: 'Sub Category',
    width: '14%',
  },
  {
    key: 'segment_category',
    render: ({ segment_category }) => (segment_category ? snakeCaseToText(segment_category) : ' '),
    title: 'Category',
    width: '14%',
  },
  {
    key: 'segment_type',
    render: ({ segment_type }) => (segment_type ? snakeCaseToText(segment_type) : ' '),
    title: 'Type',
    width: '14%',
  },
  {
    key: 'segment_source',
    render: ({ segment_source, segment_source_description }) => (
      <SourceCell source={segment_source} sourceDescription={segment_source_description} />
    ),
    title: 'Source',
    width: '14%',
  },
];
